module.exports = __webpack_public_path__ + "img/REG_ALIM_SANS_GLUTEN2.bac14870.svg";